import React from "react";
import { useSceneStore } from "../../store/sceneStore";
import type { CameraMode } from "../../types/astronomy";

const modes: { value: CameraMode; label: string }[] = [
  { value: "free", label: "Livre" },
  { value: "follow", label: "Seguir corpo" },
  { value: "heliocentric", label: "Heliocêntrica" },
  { value: "planetocentric", label: "Planetocêntrica" },
];

export function CameraControl() {
  const cameraMode = useSceneStore((s) => s.cameraMode);
  const setCameraMode = useSceneStore((s) => s.setCameraMode);
  const setFocusedBodyId = useSceneStore((s) => s.setFocusedBodyId);

  return (
    <div className="tls-astro-control-block">
      <label htmlFor="tls-astro-camera">Câmera</label>
      <select
        id="tls-astro-camera"
        value={cameraMode}
        onChange={(e) => setCameraMode(e.target.value as CameraMode)}
      >
        {modes.map((m) => (
          <option key={m.value} value={m.value}>
            {m.label}
          </option>
        ))}
      </select>
      <button
        type="button"
        onClick={() => {
          setCameraMode("heliocentric");
          setFocusedBodyId("sun");
        }}
      >
        Visão geral
      </button>
    </div>
  );
}
